import styled from "styled-components";

export const StyledCategoryDescription = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
`;
